import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = {
    key: 0,
    class: "search-filter__operator"
};
const _hoisted_3 = ["value"];
const _hoisted_4 = {
    key: 0,
    class: "search-filter__input search-filter__input--no-value"
};
const _hoisted_5 = {
    key: 1,
    class: "search-filter__input"
};
const _hoisted_6 = ["id"];
const _hoisted_7 = ["id"];
const _hoisted_8 = ["id"];
const _hoisted_9 = ["id"];
import { nextTick, ref, watch, computed } from 'vue';
import Icon from "./Icon.vue";
import SearchFilterDate from "./SearchFilterDate.vue";
import SearchFilterEntityChoices from "./SearchFilterEntityChoices.vue";
import SearchFilterSelect from "./SearchFilterSelect.vue";
import { searchFilterOperatorTakesValue } from "../util/SearchUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchFilterActive',
    props: {
        filter: {},
        selected: { type: Boolean },
        disableRemoval: { type: Boolean }
    },
    emits: [
        'select',
        'remove'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const choices = ref([]);
        const showChoicesDropdown = ref(false);
        const filterRefs = ref({});
        const filterLabel = computed(() => {
            return props.filter.filter.label
                // replace '*' wildcard for map attributes
                .replace(/ \*$/, '');
        });
        const emptyFilter = computed(() => {
            return props.filter.filter.input === 'select'
                && (!props.filter.value || (Array.isArray(props.filter.value) && props.filter.value.length === 0));
        });
        const isMapAttribute = computed(() => props.filter.filter.attribute.endsWith('.*'));
        const mapKey = ref(initialMapKey());
        function initialMapKey() {
            if (!isMapAttribute.value) {
                return '';
            }
            // part after the last dot
            return props.filter.attribute.substring(props.filter.attribute.lastIndexOf('.') + 1);
        }
        function onMapKeyChange() {
            // replace part after the last dot with the map key
            props.filter.attribute = props.filter.filter.attribute.replace(/\.\*$/, '.' + mapKey.value);
        }
        setChoicesValue();
        watch(() => props.filter, setChoicesValue);
        function setChoicesValue() {
            choices.value = [];
            if (props.filter.filter.type === 'choice'
                || props.filter.filter.type === 'entity'
                || props.filter.filter.type === 'country') {
                choices.value = Array.isArray(props.filter.value)
                    ? props.filter.value
                    : [];
            }
        }
        function selectFilter() {
            emit('select', props.filter);
        }
        onSelect();
        watch(() => props.selected, onSelect);
        function onSelect() {
            if (props.selected) {
                focusFilterIfSelected();
                if (props.filter.filter.type === 'choice' || props.filter.filter.type === 'country') {
                    showChoicesDropdown.value = props.selected ?? false;
                }
            }
            else {
                showChoicesDropdown.value = false;
            }
        }
        function onChoicesChange() {
            props.filter.value = choices.value;
        }
        function onEntityChoicesChange(entityIds) {
            choices.value.length = 0;
            entityIds.forEach(id => choices.value.push(id));
            onChoicesChange();
        }
        function focusFilterIfSelected() {
            if (!props.selected) {
                return;
            }
            nextTick(() => {
                filterRefs.value[props.filter.id]?.focus();
            });
        }
        function filterTakesValue(filter) {
            return searchFilterOperatorTakesValue(filter.operator);
        }
        function onDeleteKeyFilterValue() {
            const input = props.filter.filter.input;
            if (input === 'select' || input === 'bool') {
                removeFilter();
                return;
            }
            if (props.filter.value === '') {
                props.filter.value = undefined;
                return;
            }
            if (input === 'entity' || input === 'date' || input === 'datetime') {
                return;
            }
            // if already null, the whole filter should be removed
            if (props.filter.value === undefined) {
                removeFilter();
            }
        }
        function removeFilter() {
            emit('remove', props.filter);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                onClick: selectFilter,
                onKeydown: _withKeys(onDeleteKeyFilterValue, ["delete"]),
                class: _normalizeClass(["search-filter", {
                        'search-filter--active': __props.selected ?? false,
                        'search-filter--special': __props.filter.filter.category === 'special',
                        'search-filter--entity': __props.filter.filter.type === 'entity',
                        'search-filter--empty': emptyFilter.value,
                        'search-filter--no-removal': __props.disableRemoval
                    }])
            }, [
                _createElementVNode("label", {
                    for: 'filter' + __props.filter.id,
                    class: "search-filter__property"
                }, [
                    (!__props.disableRemoval)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (removeFilter()), ["prevent"])),
                            class: "search-filter__remove",
                            href: "",
                            tabindex: "-1"
                        }, [
                            _createVNode(Icon, { name: "times" })
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(filterLabel.value) + " ", 1),
                    (isMapAttribute.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((mapKey).value = $event)),
                            onChange: onMapKeyChange,
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"])),
                            class: "search-filter__map-key"
                        }, null, 544)), [
                            [_vModelText, mapKey.value]
                        ])
                        : _createCommentVNode("", true)
                ], 8, _hoisted_1),
                (__props.filter.filter.operators.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((__props.filter.operator) = $event)),
                            class: "search-filter__operator-selection",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.filter.operators, (operator) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: operator,
                                    value: operator
                                }, _toDisplayString(_ctx.$t('operator.' + operator)), 9, _hoisted_3));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, __props.filter.operator]
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["search-filter__value", {
                            'search-filter__value--selection': __props.filter.filter.input === 'select',
                            'search-filter__value--datetime': __props.filter.filter.input === 'datetime',
                        }])
                }, [
                    (!filterTakesValue(__props.filter))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('operator.' + __props.filter.operator + '.label')), 1))
                        : (__props.filter.filter.input === 'select')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(SearchFilterSelect, {
                                    filter: __props.filter,
                                    choices: choices.value,
                                    "show-choices-dropdown": showChoicesDropdown.value,
                                    selected: __props.selected ?? false,
                                    onFocus: _cache[5] || (_cache[5] = ($event) => (selectFilter())),
                                    onChange: onChoicesChange,
                                    ref: (el) => { filterRefs.value[__props.filter.id] = el; }
                                }, null, 8, ["filter", "choices", "show-choices-dropdown", "selected"])
                            ]))
                            : (__props.filter.filter.input === 'entity')
                                ? (_openBlock(), _createBlock(SearchFilterEntityChoices, {
                                    key: 2,
                                    class: "search-filter__input",
                                    filter: __props.filter,
                                    onChange: onEntityChoicesChange
                                }, null, 8, ["filter"]))
                                : (__props.filter.filter.input === 'text')
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 3,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((__props.filter.value) = $event)),
                                        class: "search-filter__input",
                                        type: "text",
                                        id: 'filter' + __props.filter.id,
                                        ref: (el) => { filterRefs.value[__props.filter.id] = el; },
                                        onFocus: _cache[7] || (_cache[7] = ($event) => (selectFilter()))
                                    }, null, 40, _hoisted_6)), [
                                        [_vModelText, __props.filter.value]
                                    ])
                                    : (__props.filter.filter.input === 'email')
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 4,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((__props.filter.value) = $event)),
                                            class: "search-filter__input",
                                            type: "email",
                                            id: 'filter' + __props.filter.id,
                                            ref: (el) => { filterRefs.value[__props.filter.id] = el; },
                                            onFocus: _cache[9] || (_cache[9] = ($event) => (selectFilter()))
                                        }, null, 40, _hoisted_7)), [
                                            [_vModelText, __props.filter.value]
                                        ])
                                        : (__props.filter.filter.input === 'number')
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 5,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((__props.filter.value) = $event)),
                                                class: "search-filter__input",
                                                type: "number",
                                                id: 'filter' + __props.filter.id,
                                                ref: (el) => { filterRefs.value[__props.filter.id] = el; },
                                                onFocus: _cache[11] || (_cache[11] = ($event) => (selectFilter()))
                                            }, null, 40, _hoisted_8)), [
                                                [_vModelText, __props.filter.value]
                                            ])
                                            : (__props.filter.filter.input === 'bool' && (__props.filter.value === undefined || typeof __props.filter.value == 'boolean'))
                                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                    key: 6,
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((__props.filter.value) = $event)),
                                                    class: "search-filter__input search-filter__input--checkbox",
                                                    id: 'filter' + __props.filter.id,
                                                    ref: (el) => { filterRefs.value[__props.filter.id] = el; },
                                                    type: "checkbox"
                                                }, null, 8, _hoisted_9)), [
                                                    [_vModelCheckbox, __props.filter.value]
                                                ])
                                                : (__props.filter.filter.input === 'date' || __props.filter.filter.input === 'datetime')
                                                    ? (_openBlock(), _createBlock(SearchFilterDate, {
                                                        key: 7,
                                                        filter: __props.filter
                                                    }, null, 8, ["filter"]))
                                                    : _createCommentVNode("", true)
                ], 2)
            ], 34));
        };
    }
});
